import NotificationManagementCreateComponent from './notification_management.create.component';

let NotificationManagementCreateModule = angular.module('notificationManagementCreate', [
  ])

  .component('notificationManagementCreate', NotificationManagementCreateComponent)

  .name;

export default NotificationManagementCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/create/index.js